module.exports = __webpack_public_path__ + "static/media/9.23f66018.jpg";